import { useCallback, useState } from 'react';

import { mapAttachmentsToLightboxFiles } from '@entities/attachment/lib';
import { IMessageAttachment } from '@entities/message/model/types';
import { IPreviewFile } from '@shared/ui/Lightbox/model/types';

export const useCommentsLightbox = () => {
    const [lightboxFiles, setLightboxFiles] = useState<IPreviewFile[]>([]);
    const [currentLightboxFileId, setCurrentLightboxFileId] = useState<
        IMessageAttachment['id'] | null
    >(null);

    const openAttachmentLightbox = useCallback(
        (attachments: IMessageAttachment[], currentAttachmentId: IMessageAttachment['id']) => {
            setLightboxFiles(mapAttachmentsToLightboxFiles(attachments));
            setCurrentLightboxFileId(currentAttachmentId);
        },
        []
    );

    const closeAttachmentLightbox = useCallback(() => {
        setLightboxFiles([]);
        setCurrentLightboxFileId(null);
    }, []);

    return {
        lightboxFiles,
        currentLightboxFileId,
        openAttachmentLightbox,
        closeAttachmentLightbox,
    };
};
